import Indicator, { IndicatorType } from '../../types/Indicator'

const ThickOrange: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'thickOrange',
  label: 'Thick Orange',
  fields: ['thickOrange'],
  excludeSelfInRHS: true,
}

export default ThickOrange
